export const REPORTS_TABLE_NAME = 'reports';
export const isReportsTable = (id: string | undefined) =>
	id === REPORTS_TABLE_NAME;
export const isPhaseColumn = (fieldName: string | undefined) =>
	fieldName !== undefined && ['phaseIn', 'phaseOut'].indexOf(fieldName) !== -1;

export const DEFAULT_DATE = '1970-01-01T00:00:00.000Z';

export const MATRIX_TYPE = 'matrix';
export const ARRAY_TYPE = 'array';
export const OBJECT_TYPE = 'object';
export const DATE_TYPE = 'date';
export const PRIMITIVE_TYPE = 'primitive';

export const isValueMatrixField = (dataType: string) => {
	return dataType === MATRIX_TYPE;
};

export const isValueArrayField = (dataType: string) => {
	return dataType === ARRAY_TYPE;
};

export const isValueObjectField = (dataType: string) => {
	return dataType === OBJECT_TYPE;
};

export const isValuePrimitiveField = (dataType: string) => {
	return dataType === PRIMITIVE_TYPE;
};

export const isValueDateField = (dataType: string) => {
	return dataType === DATE_TYPE;
};
